import React, { Fragment } from 'react'
import cn from 'classnames'
import Button from '@groovehq/internal-design-system/lib/components/Button/Button'
import AnimatedEllipsis from '@groovehq/internal-design-system/lib/components/AnimatedEllipsis/AnimatedEllipsis'
import { Form } from 'util/ui'
import { SubHeader } from 'shared/components/ui/Typography'
import ValidatedField from 'shared/components/ui/ValidatedField'
import FormError from 'shared/components/ui/Form/Error'
import PasswordRequirements from 'components/PasswordRequirements'
import { propFunc } from 'util/functions'
import { disableLastPassInputRef } from 'util/disableLastPassInputRef'
import sharedStyles from '../../../sharedForm/styles.less'
import styles from '../styles.less'
import { styles as formStyles } from './styles'

class AcceptInviteForm extends React.PureComponent {
  state = { isPasswordFocused: false }

  componentDidMount() {
    const { onLoad } = this.props
    onLoad()
  }

  handleChange = (name, _, { value, checked }) => {
    const { onChange } = this.props
    onChange(name, checked === undefined ? value : checked)
  }

  handleBlur = name => {
    const { onValidate, formFields } = this.props
    onValidate(name, formFields[name])
    if (name === 'passwordInput') {
      this.setState({ isPasswordFocused: false })
    }
  }

  handleFocus = name => {
    if (name === 'passwordInput') {
      this.setState({ isPasswordFocused: true })
    }
  }

  render() {
    const {
      formFields,
      formFieldsErrors,
      submitForm,
      canSave,
      saving,
      acceptError,
      invitationFound,
      layoutVariant,
      isLoading,
    } = this.props

    if (isLoading) {
      return (
        <div className="grui text-center">
          Loading<AnimatedEllipsis />
        </div>
      )
    }

    return (
      <Form
        size="large"
        className={cn({
          [sharedStyles.form]: true,
          [sharedStyles.formV2]: layoutVariant === 2,
          [sharedStyles.formV3]: layoutVariant === 3,
        })}
      >
        {invitationFound && (
          <Fragment>
            <Form.Field>
              <ValidatedField
                placeholder="Your first and last name"
                type="text"
                value={formFields.firstLastNameInput}
                errorMessage={formFieldsErrors.firstLastNameInput}
                onChange={propFunc(this.handleChange, 'firstLastNameInput')}
                onBlur={propFunc(this.handleBlur, 'firstLastNameInput')}
                fieldRefCallback={disableLastPassInputRef}
              />
            </Form.Field>
            <Form.Field>
              <ValidatedField
                placeholder="Your username"
                type="text"
                value={formFields.usernameInput}
                errorMessage={formFieldsErrors.usernameInput}
                onChange={propFunc(this.handleChange, 'usernameInput')}
                onBlur={propFunc(this.handleBlur, 'usernameInput')}
                fieldRefCallback={disableLastPassInputRef}
              />
            </Form.Field>
            <Form.Field>
              <ValidatedField
                placeholder="Password"
                type="password"
                value={formFields.passwordInput}
                errorMessage={formFieldsErrors.passwordInput}
                isErrorMessageHidden
                onChange={propFunc(this.handleChange, 'passwordInput')}
                onBlur={propFunc(this.handleBlur, 'passwordInput')}
                onFocus={propFunc(this.handleFocus, 'passwordInput')}
                fieldRefCallback={disableLastPassInputRef}
              />
            </Form.Field>
            {(formFields.passwordInput || this.state.isPasswordFocused) && (
              <PasswordRequirements
                value={formFields.passwordInput}
                className={cn(styles.passwordRequirements, 'grui mb-10 pl-5')}
              />
            )}
            <Form.Field>
              <ValidatedField
                placeholder="Password confirmation"
                type="password"
                value={formFields.passwordConfirmInput}
                errorMessage={formFieldsErrors.passwordConfirmInput}
                onChange={propFunc(this.handleChange, 'passwordConfirmInput')}
                onBlur={propFunc(this.handleBlur, 'passwordConfirmInput')}
                fieldRefCallback={disableLastPassInputRef}
              />
            </Form.Field>
            <Form.Field>
              <hr />
            </Form.Field>
            {acceptError && <FormError error={acceptError} />}
            <Button
              type="info"
              size="xBig"
              css={formStyles.btn}
              onClick={submitForm}
              disabled={!canSave}
              htmlType="submit"
            >
              {!saving ? 'Let’s go!' : 'One moment...'}
            </Button>
            <Form.Field>
              <p className="grui mt-12 text-center">
                By continuing, you agree to Groove&apos;s{' '}
                <span className="grui whitespace-nowrap">
                  <a
                    href="https://www.groovehq.com/our/terms"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Terms of Service
                  </a>{' '}
                  and{' '}
                  <a
                    href="https://www.groovehq.com/our/privacy"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Privacy Policy
                  </a>
                  .
                </span>
              </p>
            </Form.Field>
          </Fragment>
        )}
        {!invitationFound && (
          <Form.Field>
            <SubHeader
              size="small"
              as="h2"
              color="berry"
              className={layoutVariant === 3 && 'grui text-center'}
            >
              Invitation has expired, please ask your administrator to send you
              a new link
            </SubHeader>
          </Form.Field>
        )}
      </Form>
    )
  }
}

export default AcceptInviteForm
